import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as cartActions from '../../actions/cart';
import * as frameActions from '../../actions/frames';
import * as orderActions from '../../actions/orders';
import CoursePage from './CoursePage';

const mapStateToProps = ({
  product, frames, order, settings,
}) => ({
  ...settings,
  order,
  frames,
  variants: product.data.variants,
  productTitle: product.data.title,
  isDemo: window.bta.isDemo,
  locations: product.data.locations,
  resources: product.data.resources,
  additionalDetails: order.additionalDetails,
  onTrigger: window.xprops ? window.xprops.onTrigger : null,
  selectedLocation: order.selectedLocation,
  shopBeginningOfWeek: settings.defaultSetting.shop_beginning_of_week,
  shopDatepickerTimeInterval: settings.shop_datepicker_time_interval,
  shopDateFormat: settings.shop_date_format,
});

const mapDispatchToProps = (dispatch) => ({
  frameActions: bindActionCreators({ ...frameActions }, dispatch),
  orderActions: bindActionCreators({ ...orderActions }, dispatch),
  cartActions: bindActionCreators({ ...cartActions }, dispatch),
});

const CoursePageConnected = connect(
  mapStateToProps,
  mapDispatchToProps,
)(CoursePage);

export default CoursePageConnected;
